import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
    selectProvidedIdentificationId, selectIdentificationVerificationInput,
    selectBupaVerified, selectBupaChecked
} from '../../../../selectors/CustomerDetails';
import { verifyAccount } from '../../../../actions/';
//Components
import Select from '../../../Basic/Select';
import TextBox from '../../../Basic/TextBox';
import DatePicker from '../../../Enhanced/DatePicker';
import PhoneBox from '../../../Enhanced/PhoneBox';
import LinkButton from '../../../Basic/LinkButton';
import * as consts from '../../../../constants';
//TODO: Ensure last bill amount [?for business or residential] will be added here 
//TODO: More comments
class IdTypeforExisitngFortisBCCustomer extends React.Component {
    onGetAccount = () => {
        const p = this.props;
        p.onGetAccount(p.providedIdentificationId, p.identificationVerificationInput);
    }
    render() {
        const p = this.props;
        let identificationInput = null;
        switch (p.providedIdentificationId) {
            case "Date of birth":              
                identificationInput = (<DatePicker id="identificationVerificationInput" name="identificationVerificationInput"
                    title={p.providedIdentificationId} disabled={p.bupaVerified} required />);
                break;
            case "Primary phone number":
            case "Primary cell phone number":
            case "Secondary phone number":
            case "Secondary cell phone number":              
                identificationInput = (<PhoneBox name="identificationVerificationInput" title={p.providedIdentificationId}
                    disabled={p.bupaVerified} required />);
                break;
            case "Last invoice amount":               
                identificationInput = (
                    <div>
                        <TextBox name="identificationVerificationInput" title={p.providedIdentificationId} disabled={p.bupaVerified}
                            pattern={consts.REGEX_TWO_DECIMAL}  required />
                        <div>e.g. $99.99</div>
                    </div>);
                break;
            case "Passport number":
            case "Business number":
            case "BP number":
            case "Driver\'s licence number":             
                identificationInput = (
                    <div>
                        <TextBox name="identificationVerificationInput" title={p.providedIdentificationId} disabled={p.bupaVerified} required />
                        <div>e.g. 1234567</div>
                    </div>);
                break;
        }
        const selectItem = p.bupaChecked.map((s) => { return { id: s, name: s }; });
        const col = p.isRegister ? 'col-sm-8' : 'col-sm-6';
        return (
            <div className="col-xs-8">
                <div className="row">
                    <div className="col-sm-12">
                        <br />
                        Please select the identification you would like to provide to continue with your request:
                    </div>
                    <div className={col}>
                        <Select name="providedIdentificationId" items={selectItem} placeHolder=" " disabled={p.bupaVerified} />
                    </div>
                </div>
                {identificationInput ?
                    <div className="row">
                        <br />
                        <div className={col} >
                            {identificationInput}
                        </div>
                        <div className="col-sm-2">
                            <div>&nbsp;</div>
                            <LinkButton text="Continue" onClick={this.onGetAccount} disabled={p.bupaVerified} />
                        </div>
                        <br />
                    </div>
                    : null
                }
            </div>
        );
    }
}

IdTypeforExisitngFortisBCCustomer.propTypes = {
    onGetAccount: PropTypes.func,
    providedIdentificationId: PropTypes.number,
    identificationVerificationInput: PropTypes.string,
};
function mapDispatchToProps(dispatch) {
    return {
        onGetAccount: (identificationType, verificationValue) =>
            dispatch(verifyAccount(identificationType, verificationValue))
   
    };
}
const mapStateToProps = createStructuredSelector({
    bupaChecked: selectBupaChecked(),
    providedIdentificationId: selectProvidedIdentificationId(),
    identificationVerificationInput: selectIdentificationVerificationInput(),
    bupaVerified: selectBupaVerified(),
});
export default connect(mapStateToProps, mapDispatchToProps)(IdTypeforExisitngFortisBCCustomer);